import { Component, OnInit } from '@angular/core';
import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
import { Router } from "@angular/router";
import { MsalService } from "@azure/msal-angular";
import { BackendApiService } from 'src/app/service/backendapi.service';
import { EndpointsService } from 'src/app/service/endpoints.service';

@Component({
  selector: 'app-nav-right',
  templateUrl: './nav-right.component.html',
  styleUrls: ['./nav-right.component.scss'],
  providers: [NgbDropdownConfig]
})
export class NavRightComponent implements OnInit {
  public sessionStorage = sessionStorage;
  constructor(private router: Router, private authService: MsalService,

    private endpointsService: EndpointsService, private backendApiService: BackendApiService) { }

  ngOnInit() {
    sessionStorage.getItem('ecowas_user_name');
    if (this.sessionStorage.getItem('ecowas_user_name') == 'mtngc') {
      sessionStorage.setItem('homeCountryNameWithOp', '')
    }
    else {
      if (this.sessionStorage.getItem('homeCountryNameWithOp').includes('(')) {

        sessionStorage.setItem('homeCountryNameWithOp', sessionStorage.getItem('homeCountryNameWithOp'))

      }
      else {

        sessionStorage.setItem('homeCountryNameWithOp', '(' + sessionStorage.getItem('homeCountryNameWithOp') + ')')

      }
    }
  }

  onLogOut() {
    this.storeAnalytics();

  }

  storeAnalytics() {

    const apiUrl1 = this.endpointsService.CENTRY_LOG +
      'userName=' + sessionStorage.getItem('ecowas_user_name') + '&action=' + '&module=' + '&operation=logged_Out' + '&opname=logOut' + '&opvalue=true';
    this.backendApiService.callToApi(apiUrl1).subscribe(response => {
      console.log(response);
    });
    this.onlogout2();
  }

  onlogout2(){

    this.router.navigate(['/authentication/login']).then();
    setTimeout('location.reload()', 500);
    sessionStorage.clear();
  }
}
